export const IMAGE_PREFIX = '/_ipx/f_webp';
export const IMAGE_PATH = `${IMAGE_PREFIX}/images`;
